export default __webpack_public_path__ + "aa70405dca3fe8722e9cea2221a28b87.png";